import React from 'react';
import { Input } from '@mui/material';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';

import './textfield-wrapper.scss';

type Props = {
  name: string;
  value: string;
  handler: React.ChangeEventHandler<HTMLInputElement>;
  style?: object;
  fullWidth?: boolean;
  underlineShow?: boolean;
  placeholder?: string;
  rows?: number;
  multiLine?: boolean;
  handleKeyPress: React.KeyboardEventHandler;
  submitIconBtn: React.ReactNode;
};
export const TextField: ReactFCC<Props> = (props) => {
  const {
    placeholder = 'Start typing...',
    fullWidth = false,
    underlineShow = false,
    rows = 1,
    style = {},
    multiLine = false,
    handleKeyPress = () => undefined,
    name,
    value,
    handler,
    submitIconBtn,
  } = props;
  // Default BBK styles
  const basicStyles = {
    boxSizing: 'border-box',
    border: '2px solid #ccc',
    backgroundColor: '#fbfbfb',
    padding: '10px 41px 5px 5px',
    borderRadius: '3px',
    color: '#464646',
  };

  const textareaStyles = multiLine ? Object.assign(basicStyles, style) : {};
  const inputStyle = multiLine ? {} : Object.assign(basicStyles, style);

  return (
    <div className="tf-wrapper bbk-tf-wrapper">
      <Input
        name={name}
        multiline={multiLine}
        fullWidth={fullWidth}
        disableUnderline={!underlineShow}
        rows={rows}
        style={multiLine ? textareaStyles : inputStyle}
        value={value}
        onChange={handler}
        placeholder={placeholder}
        onKeyPress={handleKeyPress}
      />
      <div className="btn-layout">{submitIconBtn}</div>
    </div>
  );
};
